import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useSetAtom } from 'jotai'

import { session } from '../store'

export function LogoutView() {
  const logout = useSetAtom(session.logoutAtom)
  const navigate = useNavigate()

  useEffect(() => {
    logout().then(() => {
      navigate('/', { replace: true })
    })
  }, [logout, navigate])

  return null
}
